export const actionTypes = {
  SHOW_EDUCATORS_SURVEY: 'SHOW_EDUCATORS_SURVEY',
  HIDE_EDUCATORS_SURVEY: 'HIDE_EDUCATORS_SURVEY',
};

const showEducatorsSurvey = () => ({
  type: actionTypes.SHOW_EDUCATORS_SURVEY,
});

const hideEducatorsSurvey = (status) => ({
  type: actionTypes.HIDE_EDUCATORS_SURVEY,
  payload: { status },
});

export { showEducatorsSurvey, hideEducatorsSurvey };
